
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/[organizationId]/inbox",
      function () {
        return require("private-next-pages/organizations/[organizationId]/inbox/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/[organizationId]/inbox"])
      });
    }
  